import React, { Fragment, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import Select from "react-select";

import { State, City } from "country-state-city";

import PageTitle from "../../layouts/PageTitle";
import { useDispatch } from "react-redux";
import { createAudience } from "../../../store/actions/AudienceActions";
import { create, updateAction } from "../../../store/actions/CommonActions";
import CustomTextarea from "../../components/Forms/CustomInputs/CustomTextarea";
import { initiativeValidationSchema } from "../../../utils/validationSchemas/MasterDataSchema";
import AddUpdateUI from "./AddUpdateUI.jsx";
import { getCities, getRbac } from "../../../services/CommonServices";
import { getUsers } from "../../../store/actions/UserActions.js";
import { removeImageFromPath, uploadFileToServer } from "../../components/Forms/FormHandler.jsx";
import { toast } from "react-toastify";

const isSaveSuccess = (response) =>
  response?.data?.success === true ||
  response?.status === 200 ||
  response?.status === 201;

const AddUpdateInitiative = () => {
  const { state } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedCity, setSelectedCity] = useState({});
  const [selectedCurator, setSelectedCurator] = useState({});
  useEffect(() => {
    dispatch(getCities());
    dispatch(getUsers({ roles: 'abhivyakti' }));
  }, []);
  let initialValues = {
    title: "",
    edition: "",
    start_date: "",
    end_date: "",
    city: "",
    curator: "",
    description: "",
  };
  // const cities = City.getCitiesOfState("IN", "GJ").map((s) => {
  //   return { ...s, label: s.name, value: s.name };
  // });
  if (state) {
    initialValues = { ...state, city: state?.city?._id, curator: state?.curator?._id };
  }

  useEffect(() => {
    if (state) {
      if (state.city) {
        setSelectedCity({
          label: state.city.name,
          value: state.city._id,
        });
      }
      if (state.curator) {
        setSelectedCurator({
          label: `${state.curator.firstname} ${state.curator.lastname}`,
          value: state.curator._id,
        });
      }
    }
  }, [state]);

  const handleFormSubmit = async (values, { setSubmitting }) => {
    try {
      setSubmitting(true);
      if (values.banner instanceof File) {
        const file = values.banner;
        try {
          // 🔍 upload file
          const url = await uploadFileToServer(file);
          // console.log('svnioevs', url);
          values.banner = url;
        } catch (err) {
          toast.error("Error uploading file");
          console.error(err);
          return; // stop submit
        }
      } else if (values.banner == "" && initialValues.banner != "") {
        await removeImageFromPath(initialValues.banner);
      }
      let response;
      if (state) {
        response = await updateAction(
          `initiative/${state._id}`,
          "initiative",
          values
        );
      } else {
        response = await create("initiative", "initiatitve", values);
      }
      if (isSaveSuccess(response)) {
        navigate("/initiatives", { replace: true });
      }
    } catch (error) {
      // errors surfaced by apiCaller interceptor
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AddUpdateUI
      handleFormSubmit={handleFormSubmit}
      state={state}
      initialValues={initialValues}
      selectedCity={selectedCity}
      setSelectedCity={setSelectedCity}
      selectedCurator={selectedCurator}
      setSelectedCurator={setSelectedCurator}
    />
  );
};

export default AddUpdateInitiative;
